'use client';

import type { ICollectionPipelineStatusV3 } from '@repo/sdk';
import type { JSX } from 'react';
import { PipelineStepBadge } from '../pipeline-step-badge';
import { PipelineStepCell } from '../pipeline-step-cell';
import { PipelineStepDialog } from '../pipeline-step-dialog';

interface ISrtStepProps {
  item: ICollectionPipelineStatusV3;
}

export function SrtStep({ item }: ISrtStepProps): JSX.Element {
  return (
    <PipelineStepCell
      badge={<PipelineStepBadge step={item.steps.srtImported} />}
      renderDialog={(open, onOpenChange) => (
        <PipelineStepDialog
          open={open}
          onOpenChange={onOpenChange}
          title="SRT Imported"
          description="Subtitle file (.srt) imported and parsed for this collection. Required for every downstream step."
          dataHref={`/sys/collections/${item.collectionId}/subtitle`}
          dataLabel="Open subtitle page"
        />
      )}
    />
  );
}
